import { render, staticRenderFns } from "./windowGastosCobiertosComponent.vue?vue&type=template&id=56d1c53c&"
import script from "./windowGastosCobiertosComponent.vue?vue&type=script&lang=js&"
export * from "./windowGastosCobiertosComponent.vue?vue&type=script&lang=js&"
import style0 from "./windowGastosCobiertosComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardText,VCol,VContainer,VIcon,VImg,VRow,VTooltip})
